"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var component_1 = require("./component");
exports.styleSinglentone = component_1.styleSinglentone;
var singlentone_1 = require("./singlentone");
exports.stylesheetSinglentone = singlentone_1.stylesheetSinglentone;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-style-singleton/dist/index.js
// module id = 966
// module chunks = 58